




import { Vue, Component, Prop } from 'vue-property-decorator';

import { SlotType, Slot } from '../types';

import DetailedSlotReserved from './DetailedSlotReserved.vue';
import DetailedSlotVacation from './DetailedSlotVacation.vue';
import DetailedSlotFree from './DetailedSlotFree.vue';
import DetailedSlotHighlight from './DetailedSlotHighlight.vue';
import DetailedSlotPatientChosen from './DetailedSlotPatientChosen.vue';

import { ISODateTimeRange } from '@/utils/date/types';
import { Maybe } from '@/types/common';

const slotComponentMap = {
    [SlotType.Reserved]: DetailedSlotReserved,
    [SlotType.Vacation]: DetailedSlotVacation,
    [SlotType.Free]: DetailedSlotFree,
    [SlotType.Request]: null,
    [SlotType.Highlight]: DetailedSlotHighlight,
    [SlotType.PatientChosen]: DetailedSlotPatientChosen,
}

@Component({
    components: {
    },
})
export default class DetailedCalendarSlot extends Vue {
    @Prop() event!: Slot
    @Prop({ default: '' }) highlight!: Maybe<ISODateTimeRange>;

    get slotComponent() {
        return slotComponentMap[this.event.type];
    }
}
